<footer class="flex align-items-center gap-2">
  <!--
  todo: help not implemented yet
  @if (helpKey) {
    <app-help-button [key]="helpKey" />
  }-->

  @if (!hideCancelLink) {
    <app-cancel-link
      (cancelled)="onCancelClick()"
      [level]="cancelLevel"></app-cancel-link>
  }

  @if (showRemoveButton) {
    <app-action-button
      [text]="true"
      action="remove"
      (click)="onRemoveClick()"
      type="button">
    </app-action-button>
  }

  @if (isEditMode) {
    <app-action-button class="ml-auto" action="edit" type="submit">
    </app-action-button>
  } @else {
    <app-action-button class="ml-auto" action="add" type="submit">
    </app-action-button>
  }
</footer>
